import React, {useEffect, useRef, useState} from "react";
import {Checkbox, Input, Modal, notification, Tooltip,Carousel} from "antd";
import {Link, useNavigate} from "react-router-dom";
import pic_mask from "../../images/login/pic_mask.png";
import login_pic from "../../images/login/login_pic.png";
import login_pic2 from "../../images/login/login_pic2.png";
import login_pic3 from "../../images/login/login_pic3.png";
import logo from "../../images/login/logo3.png";
import login_icon01 from "../../images/login/login_icon01.png";
import login_icon02 from "../../images/login/login_icon02.png";
import close from "../../images/close.svg";
import falogo from "../../images/login/falogo.png";
import falogo2 from "../../images/login/falogo2.png";
import click from "../../images/login/click.png";
import {isAuth, login} from '../../services/login';
import {getNowAgreement} from '../../services/privatyAgreement';
import config from "../../configs/BaseConfig";
import {I18nMessagesFun} from '../../services/I18nMessages';
import {initUserInfo} from "../../services/user";
import FunctionCommon, {getCookie, getCurrentUser, getFirstMenu, getLanguage} from "../../commons/FunctionCommon";
import {showConfirmModal} from "../../components/Modal/GlobalModal";
import BaseConfig from "../../configs/BaseConfig";

function Login() {

  const {I18nMessages,getMessageDatas} = I18nMessagesFun()
  const navigate = useNavigate();
  getMessageDatas("login,authCookie,messages");
  const lag = getLanguage();
  const [font] = useState(localStorage.getItem(lag));
  const [type] = useState(lag);
  const [language] = useState([
    {
      type: "en_US",
      lable: "EN",
    },
    {
      type: "zh_CN",
      lable: "中",
    },
  ]);
  const tabChange = (type) => {
    showConfirmModal({
      title:I18nMessages.messages['msg.language.switch.title'],
      content:I18nMessages.messages['msg.language.switch.content'],
      showCancel:true,
      confirmButton:I18nMessages.messages['button.confirm_anti'],
      cancelButton:I18nMessages.messages['button.cancel_anti'],
      callback:()=>{
        localStorage.setItem('language',type);
        window.location.reload();
      }
    })
  };


  const [isChecked,setIsChecked]=useState(false);
  const [isChecked1,setIsChecked1]=useState(false);
  const [isChecked2,setIsChecked2]=useState(false);
  const [flag,setFlag]=useState(false);
  const [flag2,setFlag2]=useState(false);
  const [currentAgreement,setCurrentAgreement]=useState(null);
  const onChange = (e,type) => {
      let checked =false;
      if(type==1){
          checked=isChecked1;
      }else{
          checked=isChecked2;
      }
    if(authFlag||checked){
        if(type==1){
            setIsChecked1(e.target.checked);
        }else{
            setIsChecked2(e.target.checked);
        }
      setFlag(true);
    }else{
    getAuth();
    showModal(type==1?'privacy':'transborder');
    }

  };
  const onChangeNo1 = (e) => {
    setIsChecked1(e.target.checked);
  };
  const onChangeNo2 = (e) => {
    setIsChecked2(e.target.checked);
  };
  useEffect(() => {
    setIsChecked(isChecked1 && isChecked2);
  }, [isChecked1, isChecked2]);
  const openNotification = (placement,title,msg) => {
    notification.warning({
      message: `${title}`,
      description:msg,
      placement,
      style:{
        paddingRight:'40rem'
        },
    });
  };
  const handleOk = () => {
    if(!isBottom&&!authFlag){
      //提示都要勾选
      openNotification('top','',I18nMessages.messages['login.noRead']);
      return;
    }
    if(currentAgreement === 'privacy' && !isChecked1){
      //提示都要勾选
        openNotification('top','',I18nMessages.messages['login.checkedPrivacy']);
       return;
    }
    if(currentAgreement === 'transborder' && !isChecked2){
      //提示都要勾选
        openNotification('top','',I18nMessages.messages['login.checkedPrivacy']);
       return;
    }
    setIsModalOpen(false);
    setIsChecked(isChecked1&&isChecked2);
    setButStyle({
      width: "420rem",
      background:'#5db8b2',
    });
  };
  // 设置全局字体样式
  useEffect(() => {
    document.body.style.fontFamily = font;
  }, [font]);
  const [richText,setRichText]=useState('');
  const [agreementId,setAgreement]=useState('');
  const [agreementTime,setAgreementTime]=useState('');

  const getAgreement =() => {
		getNowAgreement({}, (response) => {
			if (response !== undefined && response != null && response.code === 0) {
        setAgreement(response.agreement.id);
        setRichText(type==='en_US'?response.agreement.contentEn:response.agreement.contentCn);
        setAgreementTime(response.agreement.releaseDateStr);
			} 
		});
	};
  const [authFlag,setAuthFlag]=useState(false);
  const [authCookie,setAuthCookie]=useState(false)
  var allow=false;
  const getAuth =async() => {
    if(!username&&!inputUsernameRef.current.input.value){
          setIsChecked(isChecked&&isBottom?true:false);
          setIsChecked1(isChecked1&&isBottom?true:false);
          setIsChecked2(isChecked2&&isBottom?true:false);
          allow=isChecked&&isBottom?true:false;
      return false;
    }
		await isAuth({userName:username||inputUsernameRef.current.input.value}, (response) => {
			if (response !== undefined && response != null && response.code === 0) {
              setAuthCookie(response.authCookie);
              setCookieStatus(response.authCookie);
              if(response.authCookie){
                document.cookie = "cookieStatus="+response.cookieStatus;
              }
              FunctionCommon.sensorsSwitch(response.cookieStatus);
              if (response.authFlag) {
                setIsChecked(true);
                setIsChecked1(true);
                setIsChecked2(true);
                setButStyle({
                  width: "420rem",
                  background:'#5db8b2',
                });   
                allow=true;      
              } else {
                setIsChecked(isChecked && isBottom ? true : false);
                setIsChecked1(isChecked1 && isBottom ? true : false);
                setIsChecked2(isChecked2 && isBottom ? true : false);
                setButStyle({
                  width: "420rem",
                  background:isChecked && isBottom&&password&&username?'#5db8b2':'#7b8080',
                });   
                allow=isChecked && isBottom&&password&&username;      
              }
              setAuthFlag(response.authFlag);
			}
    
		});

    return true;
	};
  useEffect(() => {
    getAgreement();
  },[]);
  // 弹窗
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = (type) => {
    // getAgreement();
    setCurrentAgreement(type);
    setIsModalOpen(true);
    setFlag2(false);
    setIsDivMounted(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const CustomIcon = () => (
    <img src={close} alt="" style={{ width: "24rem", height: "24rem" }} />
  );

  const inputPwdRef = useRef(null);
  const inputUsernameRef = useRef(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);

  };
  const loginSensor =(resp,username) =>{
    // window.sensors.getDisabled();
    // window.sensors.enableSDK();
    // window.sensors.disableSDK();
    try {
      if(resp.data&&window.sensors){
        resp.data.platform_type='Web';
        window.sensors.registerPage(resp.data);
        window.sensors.track('login_success',{
          'customer_type':resp.data['customer_type'],
          'is_success':true,
          'return_code':resp.code
        })
      }
      window.sensors.login(username);
    }catch (e){
      console.log('神策登录异常',e)
    }
  }
    //执行
    const submitData =async () => {
      await getAuth();
  
      setFlag2(true);
      if(!username){
        if (inputUsernameRef.current) {
          inputUsernameRef.current.focus();
        }          
        return;
      }
      if(!password){
        if (inputPwdRef.current) {
          inputPwdRef.current.focus();
        }
        return;
      }
      if(!allow && ((!isChecked1&&currentAgreement=='privacy') || (!isChecked2&&currentAgreement=='transborder'))){
        //未勾选隐私协议
         setFlag(true);
         return;
      }
      function encryptSubmit(str){
        var encrypt = window.JSEncrypt;
        encrypt.setPublicKey(BaseConfig.loginPublic);
        return encrypt.encrypt(str);
      }
      const cookie =getCookie('sensorsdata2015jssdkcross');
      let distinctId = '';
      if(cookie){
        distinctId=JSON.parse(decodeURIComponent(cookie)).distinct_id
      }
      login({cookieStatus:cookieStatus,username:encryptSubmit(username),password:encryptSubmit(password),distinctId:distinctId,agreementId:agreementId,language:type==='zh_CN'?'zh_CN':'en_US'},
        (response) => {
          if (response !== undefined && response != null && response.code === 0) {
            loginSensor(response,username);
             config.dataConfig.carryObject.setDataItem("token", response.token);
             config.dataConfig.carryObject.setDataItem("authId", response.authId);
             // 清除工资单密码验证状态，重新登录后需要重新验证
             sessionStorage.removeItem('payslipPasswordVerified');
            initUserInfo()
                .then((userInfo) => {
                  if(getCurrentUser().category==='0'){
                    window.location.href=config.dataServer+"/manager/redirect2?path=index&token="+response.token;
                    return;
                  } else if(getCurrentUser().category==='4'){
                      showConfirmModal( {
                          content:I18nMessages.messages['login.toSupplier'],
                          confirmButton:I18nMessages.messages['button.to'],
                          showCancel:true,
                          callback:() => {
                            window.location.href='https://sail.fescoadecco.com/sail-supplier/login';
                          }
                      })
                    return;
                  }
                  const firstMenu = getFirstMenu();
                  if(firstMenu.url&&firstMenu.url!='#'){
                    window.location.href=config.context+firstMenu.url;
                    // navigate(firstMenu.url.substr(1));
                  }else{
                    window.location.href=config.context+"/";
                  }
                }).catch((error) => {
              window.location.href=config.context+"/";
            });
          }else{
            if(response&&response.msg){
              notification.error({
                message: response.msg,
                description: '',
              });
            }
          }
        });
    };
    const [butStyle,setButStyle]=useState(
      {
      width: "420rem",
      background:'#5db8b2',
     }
     )
    //滚动条检测
    const divRef = useRef(null);
    const [isDivMounted, setIsDivMounted] = useState(false);
    const [isBottom, setIsBottom] = useState(false);
    useEffect(() => {
      if (isDivMounted) {
        const checkScrollBottom = () => {
          const divElement = divRef.current;
          if (divElement) {
            const { scrollHeight, clientHeight, scrollTop } = divElement;
            return scrollTop + clientHeight + 20 >= scrollHeight;
          }
          return false;
        };
  
        const handleScroll = () => {
          if (checkScrollBottom()) {
            setIsBottom(true);
          }
        };
  
        const divElement = divRef.current;
        divElement.addEventListener('scroll', handleScroll);
  
        return () => {
          if (divElement) {
            divElement.removeEventListener('scroll', handleScroll);
          }
        };
      }
    }, [isDivMounted]);
  
    const [cookieStatus,setCookieStatus]=useState(getCookie('cookieStatus'));
    const agreementCookie =(status) => {
      console.log(status)
      FunctionCommon.sensorsSwitch(status===1);
      setCookieStatus(status);
      document.cookie = "cookieStatus="+status;
    };

    const [isDragging,setIsDragging] = useState(true);
    const handleBeforeChange = () => {
      setIsDragging(false)
    };
    const handleAfterChange = () => {
      setIsDragging(true)
    };
  return (
    <div className="loginApp" >
      <img src={logo} alt="" className="falogo" />
      {/* <img src={login_pic} alt="" className="login_bg" /> */}
      <div className="login_bg">
        <Carousel autoplay={isDragging} dots={true} dotPosition={'bottom'} effect="fade" autoplaySpeed={3000} speed={1500} draggable={true} pauseOnHover={false} beforeChange={handleBeforeChange} afterChange={handleAfterChange}>
          <div className="carItem">
            <img src={login_pic} alt="" className="loginsrc" />
            <img src={pic_mask} alt="" className="loginmask" />
          </div>

          <div className="carItem">
            <Link to="https://www.fescoadecco.com/global/?channel=sail" target = "_blank" >
              <img src={falogo} alt="" className="rtlogo" />
              <img src={login_pic2} alt="" className="loginsrc" />
              <img src={pic_mask} alt="" className="loginmask" />
              <a   className="clickPic">
                <img src={click} alt="" />
              </a>
            </Link>
          </div>
          {/*<div className="carItem">*/}
          {/*  <Link to="https://www.shinetour.com" target = "_blank" >*/}
          {/*    <img src={falogo2} alt="" className="rtlogo" />*/}
          {/*    <img src={login_pic3} alt="" className="loginsrc" />*/}
          {/*    <img src={pic_mask} alt="" className="loginmask" />*/}
          {/*    <a   className="clickPic">*/}
          {/*      <img src={click} alt="" />*/}
          {/*    </a>*/}
          {/*  </Link>*/}
          {/*</div>*/}
        </Carousel>
      </div>
      <div className="newzation newzation2 flex-y-center flex-x-between">
        {language.map((item) => (
          <a key={item.type} onClick={() => tabChange(item.type)}   className={type === item.type ? "on" : ""}>
            {item.lable}
          </a>
        ))}
      </div>
      <div className="left_login flex-y-center">
        <div className="loginBox_col">
          <div className="new_login_tit">
          <div
              className="new_login_name"
              style={{ fontSize:type==="zh_CN"?"26rem":"40rem" }}
            >
              {I18nMessages.messages['login.title1']}
            </div>

            <div className="new_login_val" hidden={type === "zh_CN"}>
              {I18nMessages.messages['login.title2']}
            </div>
          </div>
          <div className="formBox" style={{ width: "420rem" }}>
          <Tooltip title={I18nMessages.messages['login.inputUserName']} color={'red'} placement="rightBottom" open={!username&&flag2} color='white' key='white' overlayInnerStyle={{ color:'red'}}>
            <div className="login_inputBox loginfont">
              <img src={login_icon01} alt="" className="login_icon"  style={{zIndex:100}}/>
              <Input
                ref={inputUsernameRef}
                onChange={handleUsernameChange}
                onBlur={getAuth}
                placeholder= {I18nMessages.messages['loginemail.placeholder']}
                style={{ paddingLeft: "45rem" }}
              ></Input>
            </div>
            </Tooltip>
          </div>
          <div className="formBox" style={{ width: "420rem" }}>
          <Tooltip title={I18nMessages.messages['login.inputPassword']} color={'red'} placement="rightBottom" open={!password&&flag2} color='white' key='white' overlayInnerStyle={{ color:'red'}}>
            <div className="login_inputBox passwordbg loginfont">
              <img src={login_icon02} alt="" className="login_icon" />
              <Input.Password
                ref={inputPwdRef}
               onBlur={getAuth}
               onChange={handlePasswordChange}
                placeholder={I18nMessages.messages['passwd.placeholder']}
                style={{ paddingLeft: "45rem" }}
              ></Input.Password>
            </div>
            </Tooltip>
            <div  className="forget_password">
             <Link style={{color: '#d6b67b',fontSize:'15rem'}} to="/user/account/forget_password">{I18nMessages.messages['login.forgetPassword']}</Link>
            </div>
          </div>
          <Link
            to="#"
            className="new_loginBtn flex-x-center flex-y-center"
            style={butStyle} onClick={submitData} >
             {I18nMessages.messages['login.login']}
          </Link>
          <div className="checkbox_item flex-y-center">
            <Checkbox onChange={(e)=>onChange(e,1)} checked={isChecked1}></Checkbox>
            {I18nMessages.messages['login.checkBoxText']}
              &nbsp;<Link to="#" onClick={()=>showModal('privacy')} style={{paddingLeft:'0rem'}}>{I18nMessages.messages['login.privacyText']}</Link>
          </div>
          <div className="checkbox_item flex-y-center">
            <Checkbox onChange={(e)=>onChange(e,2)} checked={isChecked2}></Checkbox>
            {I18nMessages.messages['login.checkBoxText']}
              &nbsp;<Link to="#" onClick={()=>showModal('transborder')} style={{paddingLeft:'0rem'}}>{I18nMessages.messages['login.transborderText']}</Link>
          </div>
        </div>
      </div>
      <Modal getContainer={false}
        className="editorModal privacyPolicy"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closeIcon={<CustomIcon />}
        width={800}
      >
        <div className="modal_item">
          <div className="editorTit">{I18nMessages.messages['login.arrangement']}</div>
          <div className="textbg" ref={divRef}>
              <div dangerouslySetInnerHTML={{ __html: richText }}  ></div>
          </div>
          <div className="updatetime">{I18nMessages.messages['login.updateTo']} {agreementTime}</div>
          {currentAgreement === 'privacy' && (
            <div className="checkbox_item flex-y-center">
              <Checkbox onChange={onChangeNo1} checked={isChecked1}></Checkbox>
              {I18nMessages.messages['login.checkBoxText']}<Link to="#">{I18nMessages.messages['login.privacyText']}</Link>
            </div>
          )}
          {currentAgreement === 'transborder' && (
            <div className="checkbox_item flex-y-center">
              <Checkbox onChange={onChangeNo2} checked={isChecked2}></Checkbox>
              {I18nMessages.messages['login.checkBoxText']}<Link to="#">{I18nMessages.messages['login.transborderText']}</Link>
            </div>
          )}
          <div className="formItem flex-x-end">
            <div className="form_btn1" onClick={handleCancel}>
            {I18nMessages.messages['login.cancel']}
            </div>
            <div className="form_btn2" onClick={handleOk}>
            {I18nMessages.messages['login.complete']}
            </div>
          </div>
        </div>
        </Modal>
        {/* cookie提示 */}
        {!authCookie&&!cookieStatus&&<div className="cookieCont flex-x-center">
          <div className="cookieTip flex-y-center">
            <div className="text">{I18nMessages.messages['authCookie.tips']}</div>
            <div className="flex-y-start">
              <div className="cookie_btn1" onClick={()=>agreementCookie("1")}>{I18nMessages.messages['authCookie.agree']}</div>
              <div className="cookie_btn2" onClick={()=>agreementCookie("2")}>{I18nMessages.messages['authCookie.refuse']}</div>
            </div>
          </div>
        </div>}
        {/* <div className="cookieCont flex-x-center">
          <div className="cookieTip flex-y-center">
            <div className="text">We collect cookies to analyze our website traffic and performance; we never collect any personal data</div>
            <div className="flex-y-start">
              <div className="cookie_btn1">Agree</div>
              <div className="cookie_btn2">Refuse</div>
            </div>
          </div>
        </div> */}
    </div>
  );
}
export default Login;
